var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvasMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13.3333H0V2.10547L2 0H16V13.3333ZM2 11.2279H4V9.12305H2V11.2279ZM5.33333 3.68555C4.5151 4.41797 4 5.48209 4 6.66667C4 7.85109 4.51529 8.91472 5.33333 9.64713V11.2279H7.33333V10.61C7.55021 10.6464 7.77278 10.6667 8 10.6667C8.22722 10.6667 8.44979 10.6464 8.66667 10.61V11.2279H10.6667V9.64713C11.4847 8.91472 12 7.85109 12 6.66667C12 5.48209 11.4849 4.41797 10.6667 3.68555V2.10547H8.66667V2.72266C8.44983 2.68627 8.22718 2.66667 8 2.66667C7.77282 2.66667 7.55017 2.68627 7.33333 2.72266V2.10547H5.33333V3.68555ZM12 11.2279H14V9.12305H12V11.2279ZM2 7.7194H4V5.61393H2V7.7194ZM12 7.7194H14V5.61393H12V7.7194ZM2 4.21029H4V2.10547H2V4.21029ZM12 4.21029H14V2.10547H12V4.21029Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6.66667C11.3333 4.82572 9.84095 3.33333 8 3.33333C6.15905 3.33333 4.66667 4.82572 4.66667 6.66667C4.66667 8.50762 6.15905 10 8 10V10.6667C5.79086 10.6667 4 8.87581 4 6.66667C4 4.45753 5.79086 2.66667 8 2.66667C10.2091 2.66667 12 4.45753 12 6.66667C12 8.87581 10.2091 10.6667 8 10.6667V10C9.84095 10 11.3333 8.50762 11.3333 6.66667Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03026 6.78789C8.48213 6.78789 8.84844 6.43515 8.84844 6.00001C8.84844 5.56488 8.48213 5.21214 8.03026 5.21214C7.57839 5.21214 7.21208 5.56488 7.21208 6.00001C7.21208 6.43515 7.57839 6.78789 8.03026 6.78789Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.66667C7.26667 4.66667 6.66667 5.32727 6.66667 6.13334C6.66667 6.86061 7.75758 8.40606 8 8.74546C8.24242 8.40606 9.33333 6.86061 9.33333 6.13334C9.33333 5.32121 8.73333 4.66667 8 4.66667ZM8.0303 6.90909C7.51515 6.90909 7.09091 6.50303 7.09091 6C7.09091 5.49697 7.51515 5.09091 8.0303 5.09091C8.54546 5.09091 8.9697 5.49697 8.9697 6C8.9697 6.50303 8.54546 6.90909 8.0303 6.90909Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasMap);
export default __webpack_public_path__ + "static/media/CanvasMap.e92085443b76eb7e89a50e028edade21.svg";
export { ForwardRef as ReactComponent };